<template lang='pug'>
.reports-rooms.ui.statistics
  .statistic
    .value {{rooms_vaild.length}}
    .label 房间
  .statistic
    .value {{rooms_filter_checked.length}}
    .label 入住
  .statistic
    .value {{rooms_filter_avaliable.length}}
    .label 空房
  .statistic
    .value(:style='{color: color(rooms_filter_checked.length / rooms_vaild.length)}') {{$formatters.to_percent(rooms_filter_checked.length / rooms_vaild.length, 1)}}
    .label 当前房间入住率
  .statistic
    .value(:style='{color: color(overall_occupancy_rate)}') {{$formatters.to_percent(overall_occupancy_rate, 1)}}
    .label 整体出租率 ({{from_text}}起算)
  .statistic
    .value {{rooms_filter_perorder.length}}
    .label 预定

  table.ui.celled.structured.table
    thead
      tr
        th.center.aligned(rowspan=2) 房號
        th.center.aligned(colspan=4) 整體
        th.center.aligned(colspan=2) 最近30天
      tr
        th.center.aligned 出租天數
        th.center.aligned 出租率
        th.center.aligned 月租金
        th.center.aligned 平均月租金

        th.center.aligned 出租天數
        th.center.aligned 出租率
    tbody
      tr(v-for='room in rooms_details')
        th.center.aligned(@click='$router.$go.room({no: room.no})', style='cursor: pointer;') {{room.no}}
        td.center.aligned {{room.rented_days}} / {{operating_days.days}}
        td.center.aligned(:style='[{color: color(room.occupancy_rate)}, fontsize(1 - room.occupancy_rate)]') {{$formatters.to_percent(room.occupancy_rate)}}
        td.right.aligned {{room._r.price_month}} 
        td.right.aligned {{(room._r.price_month * room.occupancy_rate).toFixed(2)}} 

        td.center.aligned {{room.rented_recent}} / 30
        td.center.aligned(:style='[{color: color(room.occupancy_rate_recent)}, fontsize(1 - room.occupancy_rate_recent)]') {{$formatters.to_percent(room.occupancy_rate_recent)}}
</template>

<script>
import tinycolor from 'tinycolor2'
import { MixRoom } from '../mixins'
import config from '../../../config'

const FROM_DATE = config.startup_date

export default {
  name: 'reports-rooms',
  mixins: [MixRoom],
  computed: {
    rooms() {
      return this.$store.state.summary.rooms
    },
    from_text() {
      return this.$moment(FROM_DATE).format('YYYY/MM/DD')
    },
    rooms_vaild() {
      return this.rooms.filter(i => i.avaliable)
    },
    rooms_filter_avaliable() {
      return this.rooms_vaild
        .filter(room => this.room_state(room) === 'avaliable')
    },
    rooms_filter_checked() {
      return this.rooms_vaild
        .filter(room => this.room_state(room) === 'checked')
    },
    rooms_filter_expiring() {
      const level = this.$config.warning_color_levels[0]
      return this.rooms_sorted
        .filter(room => this.room_days_to_expired(room) < level)
    },
    rooms_filter_perorder() {
      return this.rooms_vaild
        .filter(room => (this.room_preorders(room) || []).length)
    },
    operating_days() {
      const from = this.$moment(FROM_DATE)
      const now = this.$moment()
      const days = this.$formatters.date.days_in_between(now, from)
      return { from, now, days }
    },
    overall_occupancy_rate() {
      const total_day_rooms = this.operating_days.days * this.rooms_vaild.length
  
      const rented_day_rooms = Object.values(this.rooms_details).map(r => r.rented_days).reduce((a, b) => a + b, 0)
      const rate = rented_day_rooms / total_day_rooms
      return rate
    },
    rooms_details() {
      const rooms = this.rooms_vaild
      console.log(rooms)
      const { from, now, days } = this.operating_days
      const days_to_now = days
      const recent_days_range = 30
      const from_recent = this.$moment().subtract(recent_days_range, 'days')

      console.log(`DAYS TO NOW: ${days_to_now}`)
      const total_day_rooms = days_to_now * rooms
      console.log(`DAY-ROOMS: ${total_day_rooms}`)

      const result = {}

      for (const r of rooms) {
        result[r._id] = {
          _r: r,
          no: r.no,
          rented_days: 0,
          rented_recent: 0,
        }
      }

      for (const c of this.$store.state.summary.contracts) {
        if (result[c._room]) {
          let expire = this.$moment(c.date_checkout || c.date_expire)
          let start = this.$moment(c.date_start)

          if (expire > now) expire = now
          if (from > start) start = from
          if (expire > start)
            result[c._room].rented_days += this.$formatters.date.days_in_between(expire, start)

          // recent 30 days
          if (from_recent > start) start = from_recent
          if (expire > start)
            result[c._room].rented_recent += this.$formatters.date.days_in_between(expire, start)
        }
      }

      for (const r of rooms) {
        result[r._id].occupancy_rate = result[r._id].rented_days / days_to_now
        result[r._id].occupancy_rate_recent = result[r._id].rented_recent / recent_days_range
      }

      return result
    },
  },
  methods: {
    color(num) {
      // num 0 - 1, red - green
      return tinycolor({ h: 90 - (120 * Math.max(1 - num, 0)), s: 0.8823529411764706, v: 0.8, a: 1 }).toHexString()
    },
    fontsize(num) {
      return {
        fontSize: `${(num * 0.6) + 1}em`,
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// Rooms.vue?668e79ad